import { render, staticRenderFns } from "./DSTag.vue?vue&type=template&id=4b610a48&scoped=true&"
import script from "./DSTag.vue?vue&type=script&lang=js&"
export * from "./DSTag.vue?vue&type=script&lang=js&"
import style0 from "./DSTag.vue?vue&type=style&index=0&id=4b610a48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b610a48",
  null
  
)

export default component.exports